import { IconPrefix, library, SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import config from "./icon-config";
import SizeEnum from "../../enums/size.enum";
import classMap from "../../helpers/classMap";
import getIconEnumValue from "../../helpers/getIconEnumValue";
import FaIconProps from "./fa-icon.props";

const FaIcon = (props: FaIconProps) => {
  // get size
  const getSize = (): string => getIconEnumValue(props.size);
  const iconLibrary: { pack: any; style: IconPrefix } = (config.iconLibrary as any)[
    props.library || config.defaults.iconLibrary
  ];

  // add a single pack to library
  library.add(iconLibrary.pack);

  if (!props.icon) {
    return null;
  }

  return (
    <FontAwesomeIcon
      icon={[iconLibrary.style, props.icon as any]}
      className={classMap("mpng-ux-faicon mpng-ux-icon", props.className)}
      size={(props.size !== SizeEnum.MEDIUM ? props.size : undefined) as SizeProp}
      title={props.title}
      style={{
        width: props.squared ? Number(getSize()) : undefined,
        height: props.squared ? Number(getSize()) : undefined
      }}
    />
  );
};

export default FaIcon;
